import { finite } from "@/lib/science/units";

type Field = "c1" | "v1" | "c2" | "v2";
export interface DilutionInput {
  c1: number | null;
  v1: number | null;
  c2: number | null;
  v2: number | null;
}

// C1·V1 = C2·V2. Exactly one field must be null (the unknown to solve for).
// Inputs/outputs share the same base units; the UI converts around this.
export function solveDilution(known: DilutionInput): number | null {
  const nulls = (["c1", "v1", "c2", "v2"] as Field[]).filter(
    (k) => known[k] === null,
  );
  if (nulls.length !== 1) return null;
  const vals = [known.c1, known.v1, known.c2, known.v2].filter(
    (n): n is number => n !== null,
  );
  if (!finite(...vals)) return null;

  const { c1, v1, c2, v2 } = known;
  switch (nulls[0]) {
    case "c1":
      return v1 === 0 ? null : (c2! * v2!) / v1!;
    case "v1":
      return c1 === 0 ? null : (c2! * v2!) / c1!;
    case "c2":
      return v2 === 0 ? null : (c1! * v1!) / v2!;
    case "v2":
      return c2 === 0 ? null : (c1! * v1!) / c2!;
    default:
      return null;
  }
}
